import * as yup from 'yup';
import { Actions } from './index';

export interface CoverPage {
    readonly from?: string
    readonly to?: string
    readonly message?: string
}
export const coverPageSchema = yup.object<CoverPage>({
  from: yup.string().trim(),
  to: yup.string().trim(),
  message: yup.string().trim(),
});
export interface UpdateCoverPage {
    type: Actions.UpdateCoverPage,
    payload: Partial<CoverPage>
}
export type CoverPageActions =
    | UpdateCoverPage
